/**
 * @author taulmax
 * @date 2024.11.06
 * @description 그리드 테이블 로딩 컴포넌트
 */
const GridTableLoading = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 1,
      }}
    >
      <span>로딩 중...</span>
    </div>
  );
};

export default GridTableLoading;
